import * as _ from 'lodash';
import * as React from "react";
import { Participant, RoundScore } from "../model/FixtureDetailed";
import "./FixtureScoreboardHeaderView.css";

export interface Props {
  roundScoresList: RoundScore[][];
  participants: Participant[];
  // winnerId: number; // TODO Unused
}

export interface State {
}

export class FixtureScoreboardHeaderView extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
  }

  componentWillMount() {
    this.props.roundScoresList.map(roundScores => {
      roundScores.forEach(roundScore => {
        if (roundScore.id !== this.props.participants[0].id && roundScore.id !== this.props.participants[1].id) {
          throw new Error("Provided Participants and RoundScores does not match")
        }
      });
    });
  }

  render() {
    const styledScores: string[] = this.props.roundScoresList.map(roundScores => {
      let sortedRoundScores = _(roundScores).sortBy(roundScore => roundScore.id).value();
      if (this.props.participants[0].id > this.props.participants[1].id) {
        sortedRoundScores = _(sortedRoundScores).reverse().value();
      }
      return `${sortedRoundScores[0].roundsWon}:${sortedRoundScores[1].roundsWon}`
    })


    return (
      <div className="map-stats">
        <div className="map-stats-versus-container">
          <div className="logo-name-combo">
            {/* <LogoContainer id={team1.id} /> */}
            <span>
              {this.props.participants[0].name}
            </span>
            <span>
              {this.props.participants[0].id}
            </span>
          </div>
          <div className="map-stats-scores">
          {this.props.roundScoresList.length !== 0 &&
            <h2>
                {styledScores.join(";  ")}
            </h2>
          }
          </div>

          <div className="logo-name-combo">
            {/* <LogoContainer id={team2.id} /> */}
            <span>
              {this.props.participants[1].name}
            </span>
            <span>
              {this.props.participants[1].id}
            </span>
          </div>
        </div>
      </div>
    );
  }
}
